const formatPermission = (key, permission) => {
  if (key === 'name') return permission;
  if (permission === 'Edit') return `${key}_rw`;
  if (permission === 'View') return `${key}_r`;
  return null;
};

export default formatPermission;
